import { Box, Theme, useTheme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { DetailVariant } from './index';

export interface DetailTextProps {
  variant?: DetailVariant;
}

const variantStyle = (variant: DetailVariant | undefined, theme: Theme) => {
  switch (variant) {
    case 'bold': {
      return {
        color: theme.palette.grey.midDark,
        fontWeight: 'bold',
      };
    }
    case 'error': {
      return {
        color: theme.palette.error.main,
      };
    }
    case 'success': {
      return {
        color: theme.palette.success.main,
      };
    }
    case 'warning': {
      return {
        color: theme.palette.warning.main,
      };
    }
    default: {
      return {
        'a:hover &': {
          color: theme.palette.grey.midDark,
        },
        color: theme.palette.grey.xxLightForegroundSmall,
      };
    }
  }
};

const DetailText: React.FC<PropsWithChildren<DetailTextProps>> = ({ children, variant }) => {
  const theme = useTheme();

  if (!children) {
    return null;
  }

  return (
    <Box
      component="span"
      data-testid="Detail-text"
      sx={{
        alignSelf: 'center',
        fontSize: '.85em',
        lineHeight: '1.3rem',
        minHeight: '1.3rem',
        whiteSpace: 'nowrap',
        ...variantStyle(variant, theme),
      }}
    >
      {children}
    </Box>
  );
};

export default DetailText;
